import { Bar, Line } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import './chartConfig';
import { LineChartData } from './types';

interface YearComparisonChartProps {
  chartData: LineChartData;
}

function YearComparisonChart({ chartData }: YearComparisonChartProps) {
  const { t } = useTranslation();

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top' as const,
      },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            const label = context.dataset.label || '';
            return `${label}: € ${context.parsed.y.toLocaleString('nl-NL', { minimumFractionDigits: 2 })}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value: any) {
            return `€ ${value.toLocaleString('nl-NL')}`;
          },
        },
      },
    },
  };

  return (
    <div>
      <h3>{t('financialdashboard.year-comparison-chart-title')}</h3>
      {chartData.datasets.length ? (
        <Bar data={chartData} options={options} />
      ) : (
        <p>{t('financialdashboard.year-comparison-no-data')}</p>
      )}
    </div>
  );
}

export default YearComparisonChart;
